import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ArrowLeftSvg from '@/assets/ArrowLeft.svg';

const ArrowLeft = ({ size, variant, className }: IconProps) => (
  <img
    src={ArrowLeftSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ArrowLeft;
